import { type MutationTree } from 'vuex';

import { type IPrivateContactAllianceState } from './types';

export const RECEIVE_BY_ALLIANCE = 'receiveByAlliance';

export const mutations: MutationTree<IPrivateContactAllianceState> = {
    [RECEIVE_BY_ALLIANCE](_state: IPrivateContactAllianceState, { allianceId, idList }: { allianceId: number; idList: number[] }) {
        _state.byAlliance.set(allianceId, idList);
    }
};
